import { SiChatbot } from "react-icons/si";
import { RiAdminLine } from "react-icons/ri";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import "./Sidenav.css";

export const navData = [
  {
    id: 0,
    icon: <SiChatbot className={`sideitemicon`} size={20} />,
    text: "Chat",
    link: "/chat",
  },
  {
    id: 1,
    icon: <HiOutlineDocumentAdd className={`sideitemicon`} size={20} />,
    text: "Add Content",
    link: "/addcontent",
  },
  {
    id: 2,
    icon: <RiAdminLine className={`sideitemicon`} size={20} />,
    text: "Admin",
    link: "/admin",
  },
];
